import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import { useKeysStore } from '../../../../core/store/useKeysStore';

function List() {
    const profileFilter = chooseProfileFilter();
    const { keys } = useKeysStore();
    const pathFrontEnd = '/salaryequalities/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllDocumentTypes: config.endpoints.backend + 'documenttypes/getall',
        endpointDelete: `${config.endpoints.backend}documentations/delete`,
        endpoint: config.endpoints.backend + 'documentations/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_document_type_id',
                type: 'select',
                label: 'Tipo',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllDocumentTypes,
                    label: 'name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'period',
                name_start: 'date_start',
                name_end: 'date_end',
                type: 'date_period',
                label: 'Data',
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Documentações',
        labelTitleButtonAdd: 'Incluir nova documentação',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        canDownload: true,
        fieldToDownload: 'file',
        formFilters: filters,
        filter: {
            ...profileFilter,
            pdc_category_id: keys?.default_foreign_key?.pdc_documentation_categories?.salary_equality,
            pdc_document_type_id: keys?.default_foreign_key?.pdc_document_types?.salary_equality
        },
        columns: [
            {
                name: 'document_type',
                label: 'Tipo de Documento'
            },
            {
                name: 'title',
                label: 'Título'
            },
            {
                name: 'publish_date',
                label: 'Data de Publicação'
            },
            {
                name: 'created_at',
                label: 'Data de Criação'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
